import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Thanks from "@/pages/Thanks";

export const Route = createFileRoute("/_public/thanks")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Thanks \u2014 We Got It | Modern Fence Install", "Your request reached us. A real fence expert will reply within 1 business day. Need it sooner? Call (888) 416-3144.", "/thanks", true),
  component: Thanks,
});
